module.exports = __webpack_public_path__ + "img/controller-xboxone.d12b4c4c.png";